import { Component, OnInit, ChangeDetectorRef } from '@angular/core';

import { Inspection } from '../../shared/models/index';
import { PluginComponent } from '../plugin.component';
import { BasePlugin } from '../base-plugin.component';
import { CustomerSelectorPluginService } from './customerselector-plugin.service';

@Component({
    templateUrl: './customerselector.component.html',
    standalone: false
})
export class CustomerSelectorPluginComponent extends BasePlugin implements OnInit {
  public plugin: any;
  public inspection: Inspection;
  public customer: any;
  public languageValue = '';

  constructor(private cdRef: ChangeDetectorRef, private service: CustomerSelectorPluginService) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.service.getCountries().subscribe((data: any) => {
      this.customer = inspection.insptectionInspectionCustomer ? inspection.insptectionInspectionCustomer : null;
      this.cdRef.detectChanges();
    });
  }

  getEditRoute() {
    return [
      this.inspection && this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.inspection ? this.inspection.id : '',
      'plugins',
      this.plugin ? this.plugin.id : '',
      'customerselector',
      'edit'
    ];
  }
}

PluginComponent.plugins['customerselector'] = CustomerSelectorPluginComponent;
